<app-accordion [showArrow]="!!taxes && taxes.length > 0">
  <span class="weight-medium is-size-6" title>
    {{ title }}
    <ng-content select="[extra-title]"></ng-content>
  </span>
  <div *ngIf="!priceOnBottom" class="column" price>
    <span class="is-pulled-right weight-medium is-size-6" [ngClass]="{ red: hasAmountColor }">
      {{
        !!taxAmount?.currency
          ? (taxAmount?.amount | currency : taxAmount?.currency : 'symbol' : '1.2-2' : 'en-US')
          : (taxAmount?.amount | number : '1.2-2' : 'en-US')
      }}
    </span>
  </div>

  <div *ngIf="!!taxes && taxes?.length > 0" content>
    <div class="column is-offset-1">
      <div *ngFor="let taxe of taxes" class="columns">
        <app-fare-by-type [type]="type" class="is-95-width" [taxesByType]="taxe"></app-fare-by-type>
      </div>

      <!-- Total; Position Bottom-->
      <div
        class="columns weight-medium is-size-6"
        *ngIf="priceOnBottom"
        title="{{ noReefundableTaxesTooltip | translate }} "
      >
        <div class="column pl-0">
          {{ 'cancellation-info.refund-fare.total' | translate }}
        </div>
        <div class="column pr-4">
          <span class="is-pulled-right">
            {{ taxAmount?.amount | currency : taxAmount?.currency : 'symbol' : '1.2-2' : 'en-US' }}
          </span>
        </div>
      </div>

      <!-- Total; Position Bottom-->
    </div>
  </div>
</app-accordion>
